function unwrapValue(value) {
    let current = value;
    let depth = 0;

    while (
        current &&
        typeof current === 'object' &&
        'value' in current &&
        depth < 5
    ) {
        current = current.value;
        depth += 1;
    }

    return current;
}

function hasVisibleButtonText(value) {
    const raw = unwrapValue(value);
    if (raw == null || typeof raw === 'boolean') return false;

    const text = typeof raw === 'number' ? String(raw) : raw;
    if (typeof text !== 'string') return false;

    return Boolean(
        text
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;|&#160;|&#xa0;/gi, ' ')
            .replace(/\u00a0|\u200b|\ufeff/g, '')
            .replace(/(\*\*|__|~~|\*|_|`)/g, '')
            .trim()
    );
}

function normalizeButtonText(value) {
    if (!hasVisibleButtonText(value)) return '';

    const raw = unwrapValue(value);
    return String(raw).trim();
}

module.exports = { hasVisibleButtonText, normalizeButtonText };
